// Platform-agnostic theme contract — consumed by design-system-web (CSS) and design-system-native (StyleSheet)

/** The canonical identifier for a registered theme. Extend this union when adding custom themes. */
export type ThemeId = "light" | "dark";

/** The OS-level color scheme, used to resolve the 'system' preference. */
export type SystemColorScheme = "light" | "dark";

/** What the user explicitly chooses: a specific theme or 'system' (follow OS). */
export type ThemePreference = "system" | ThemeId;

/** Metadata for a registered theme entry in THEME_REGISTRY. */
export interface ThemeConfig {
  id: ThemeId;
  label: string;
  /** Which OS color scheme this theme corresponds to (used by resolveTheme). */
  colorScheme: SystemColorScheme;
  /**
   * True for HeroUI's built-in 'light' and 'dark' themes.
   * Built-in light → :root, [data-theme="light"] selector.
   * Built-in dark  → .dark, [data-theme="dark"] selector.
   * Custom themes use [data-theme="..."] only.
   */
  builtin?: boolean;
}

export const DEFAULT_THEME_ID: ThemeId = "light";

/** Default preference: follow the OS color scheme. */
export const DEFAULT_THEME_PREFERENCE: ThemePreference = "system";
